import React from "react";
import OurServiceItem from "../general/ourServiceItem";

const ItSolutions = () => {
  return (
    <section className="revamp-services section-padding">
        <div className="container">
            <div className="row mb-50">
                <div className="col-12 col-lg-12">
                    <div className="section-title text-center">
                        <span className="revamp-section-badge" style={{marginBottom: '30px', display: 'inline-block'}}>Popular IT services</span>
                        <h1 className="revamp-section-title">Our Professional Solutions <br />
                            For IT Business</h1>
                    </div>
                </div>
            </div>

            <div className="row">

                <OurServiceItem iconClass={"fas fa-laptop-code"} caption={"Digitizing Your Business"} description={"Get your business online with web design, social media, ads, and marketing campaigns built to grow sales."} />

                
                <OurServiceItem
                iconClass={"fas fa-building"}
                caption={"Co-Working Space"}
                description={<p className="mb-4">Get a professional business address, dedicated desks, and private offices for your growing team.</p>}
                button={
                    <a
                    href="https://academy.abiatechhub.com/"
                    className="revamp-btn revamp-btn--primary mt-5"
                    style={{ display: "inline-flex", justifyContent: "center" }}
                    >
                    Workspace <i className="fas fa-arrow-right"></i>
                    </a>
                }
                />


                <OurServiceItem iconClass={"fas fa-share-alt"} caption={"Social Media Management"} description={"Build a stronger brand, reach the right audience, and turn social engagement into sales."} />


                <OurServiceItem iconClass={"fas fa-bullhorn"} caption={"Google and Facebook Ads"} description={"Reach more customers with targeted Google and Facebook ads that help your business grow."} />

            </div>
        </div>
    </section>
  );
};

export default ItSolutions;
